import * as React from 'react';

import { IconProps } from './types';

const MiddleAlign: React.FC<IconProps> = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 11" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M5 0h2c.552 0 1 .448 1 1v9c0 .552-.448 1-1 1H5c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1z" />
      <rect width="12" height="1" y="5" rx=".5" />
    </g>
  </svg>
);

export default MiddleAlign;
